export const COMPANY = {
  name: "Silvertree Solutions",
  logo: "/logo-hex.webp",
  wordmark: "/wordmark-v3.webp",
  theme: "Technology clarity for growing businesses",
  tagline: "Technology clarity for growing businesses",
  geo: "Headquartered in Oklahoma, serving businesses across the United States.",
  positioning:
    "Silvertree Solutions helps growing U.S. businesses make better technology decisions through IT strategy, business analysis, cybersecurity readiness, systems integration planning, software modernization guidance, project leadership, and practical execution support.",
  promise:
    "We help growing businesses reduce technology risk, modernize systems, improve workflows, and make confident IT decisions that support sustainable growth.",
  email: "contact@silvertreesolutions.co",
  phone: "(405) 254-6048",
  hq: "Oklahoma — serving clients nationwide",
  social: {
    linkedin: "https://www.linkedin.com",
  },
};

export const IMAGES = {
  heroMeeting: "/images/hero-meeting.webp",
  strategyMeeting: "/images/strategy-meeting.webp",
  dashboard: "/images/dashboard.webp",
  workshop: "/images/workshop.webp",
  okc: "/images/okc.webp",
  collaboration: "/images/collaboration.webp",
  automation: "/images/automation.webp",
};

export const NAV = [
  { label: "IT Support", to: "/business-it-support" },
  { label: "Services", to: "/services" },
  { label: "Problems We Solve", to: "/problems" },
  { label: "Industries", to: "/industries" },
  { label: "Resources", to: "/resources" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_LINKS = [
  { label: "Business IT Support", to: "/business-it-support" },
  { label: "Services", to: "/services" },
  { label: "Problems We Solve", to: "/problems" },
  { label: "Industries", to: "/industries" },
  { label: "Methodology", to: "/methodology" },
  { label: "Resources", to: "/resources" },
  { label: "Insights", to: "/insights" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Pricing & Engagement", to: "/pricing" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PRIMARY_CTA = "Schedule a Technology Health Assessment";

export const SECONDARY_CTA = "Download the IT Readiness Checklist";

export const COMPANY_SIZES = [
  "1–9 employees",
  "10–49 employees",
  "50–99 employees",
  "100–250 employees",
  "250–500 employees",
  "500+ employees",
];

export const CONTACT_METHODS = ["Email", "Phone", "Either"];

// ---------- Services (12, deep content) ----------

export const LOCATIONS = [
  "Oklahoma City",
  "Edmond",
  "Norman",
  "Tulsa",
  "Dallas",
  "Kansas City",
  "Nationwide (remote)",
];

export const DIFFERENTIATORS = [
  {
    title: "More strategic than IT support",
    body: "We focus on business outcomes and direction — not break/fix tickets.",
    icon: "Compass",
  },
  {
    title: "More business-focused than developers",
    body: "We start with value and operations, not code and tools.",
    icon: "Briefcase",
  },
  {
    title: "More accessible than big consulting",
    body: "Practical, right-sized guidance without the overhead and complexity.",
    icon: "Users",
  },
  {
    title: "More implementation-aware than pure strategy",
    body: "Advice grounded in how the work actually gets executed.",
    icon: "ShieldCheck",
  },
];

// ---------- Founder ----------
export const FOUNDER = {
  name: 'Charles "Drew" Harger',
  shortName: "Drew Harger",
  title: "Founder & Principal Consultant",
  headshot: "/founder-drew-harger.webp",
  summary:
    "Silvertree Solutions is led by Charles \u201cDrew\u201d Harger, a senior technology executive, software engineer, and consultant with more than two decades of experience delivering mission-critical systems across healthcare, pharmacy, government, and enterprise environments.",
  homepageBody:
    "This founder-led model gives clients direct access to senior-level judgment from the beginning \u2014 not generic consulting frameworks or disconnected handoffs. It is built around practical leadership, disciplined analysis, and the ability to translate complex business and technical challenges into clear, executable solutions.",
  bio: [
    "Silvertree Solutions is led by Charles \u201cDrew\u201d Harger, a senior technology executive, software engineer, and consultant with more than two decades of experience delivering mission-critical systems across healthcare, pharmacy, government, and enterprise environments.",
    "Drew brings a rare combination of technical depth, operational awareness, and strategic leadership. His background includes pharmacy management systems, healthcare technology modernization, EDI-driven business workflows, regulatory compliance initiatives, cloud services, database architecture, systems integration, and large-scale legacy system transformation. He has led teams, designed enterprise platforms, supported regulated data environments, and delivered technology solutions where reliability, accuracy, and execution matter.",
    "This founder-led model gives clients direct access to senior-level judgment from the beginning. Silvertree Solutions is not built around generic consulting frameworks or disconnected handoffs. It is built around practical leadership, disciplined analysis, and the ability to translate complex business and technical challenges into clear, executable solutions.",
    "For organizations seeking a trusted technology partner, Silvertree Solutions provides executive-level guidance grounded in real-world delivery experience. Clients benefit from working with a founder who understands not only how systems are built, but how they must perform inside demanding business, operational, and regulatory environments.",
  ],
  highlights: [
    "20+ years delivering mission-critical systems",
    "Healthcare, pharmacy, government & enterprise",
    "Legacy transformation & systems integration",
    "Regulated data & compliance environments",
  ],
};

// ---------- Resources ----------
